module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/settings/PaymentLayout.ejs -->\n<form class="form-horizontal" role="form">\n    <div class="form-group">\n        <label class="col-sm-3 control-label">\n            Payment Settings Per Location\n            <i class="fa fa-question-circle" data-toggle="tooltip"\n                data-placement="top" data-container="body"\n                title="Select the location for which you want to change\n                    payment settings, or \'All Locations\' to edit default\n                    payment settings.">\n            </i>\n        </label>\n        <div class="col-sm-9">\n            <select name="location" class="form-control chosen-select js-ext\n                js-ext-location">\n                ';
 locations.forEach(function(location) { 
__p+='\n                    <option value="'+
((__t=( location.id ))==null?'':_.escape(__t))+
'"\n                        '+
((__t=( locationId === location.id ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n                        '+
((__t=( location.get('name') ))==null?'':_.escape(__t))+
'\n                        '+
((__t=( location.get('primary') ? '(Default Settings)' : '' ))==null?'':_.escape(__t))+
'\n                    </option>\n                ';
 }) 
__p+='\n            </select>\n        </div>\n    </div>\n\n    <div class="js-ext js-ext-settings-container payment-settings">\n    </div>\n</form>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/settings/PaymentLayout.ejs
// module id = 852
// module chunks = 1